import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Card } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { ReportCard } from "../../../../components/Admin/Report/ReportCard";
import { NotesByGrade, NotesByStudent } from "../../../../components/Admin/Report/Academic";
import { usePermissions } from "../../../../hooks";
import "./Academic.scss";

export function Academic() {
  const { hasPermission } = usePermissions();
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({ title: "", component: null });

  if (!hasPermission("grade", "read")) {
    return <Navigate to="/admin" replace />;
  }

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

  const openNotesByGrade = () => {
    setModalConfig({
      title: "Reporte de Cursos por Docente",
      component: <NotesByGrade onClose={onOpenCloseModal} />,
    });
    onOpenCloseModal();
  };

  const openNotesByStudent = () => {
    setModalConfig({
      title: "Reporte de Cursos por Docente",
      component: <NotesByStudent onClose={onOpenCloseModal} />,
    });
    onOpenCloseModal();
  };

  const reports = [
    {
      title: "Notas por Grado",
      icon: "user",
      onClick: openNotesByGrade,
    },
    {
      title: "Notas por Estudiante",
      icon: "user",
      onClick: openNotesByStudent,
    },
  ];

  return (
    <>
      <div className="admin-page m-2">
        <Card.Group itemsPerRow={3} stackable>
          {reports.map((report, index) => (
            <ReportCard
              key={index}
              title={report.title}
              icon={report.icon}
              onClick={report.onClick}
            />
          ))}
        </Card.Group>

        <BasicModal
          show={showModal}
          close={onOpenCloseModal}
          title={modalConfig.title}
          size="small"
        >
          {modalConfig.component}
        </BasicModal>
        
      </div>
    </>
  );
}